module.exports = __webpack_public_path__ + "img/cash-voucher.3861f5af.png";